module.exports = __webpack_public_path__ + "img/wa-logo.78965858.png";